import React from 'react'
import { F0TagStatus } from '@factorialco/f0-react'
import {
  getTicketPriorityLabel,
  getTicketPriorityVariant,
} from 'modules/ticketing/lib/ticketPriority'

interface TicketPriorityProps {
  priority: string
}

export const TicketPriority: React.FC<TicketPriorityProps> = ({ priority }) => {
  return (
    <F0TagStatus
      text={getTicketPriorityLabel(priority)}
      variant={getTicketPriorityVariant(priority)}
    />
  )
}

export default TicketPriority
